
const InstructorCard = ({ name, title, image, url }) => {
    return (
        <div className="instructor-card">
            <div className="picture">
                <img className="img-fluid" src={image} alt='' />
            </div>
            <div className="team-content">
                <h3 className="name">{name}</h3>
                <h4 className="title">{title}</h4>
            </div>
            <div className="about">
                <a href={url} aria-hidden="true" target="_blank" rel="noreferrer">Hakkında</a>
            </div>
        </div>
    )
}

export default InstructorCard